import { css } from "@emotion/react";

import { colors } from "../../../../styles";

export const container = css`
  margin-top: 20px;
  background-color: ${colors.white};
  padding: 15px;
  border-radius: 5px;
`;

export const detailsContainer = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const detailEntry = css`
  min-height: 80px;
  flex-shrink: 0;
  width: 190px;

  @media only screen and (max-width: 40em) {
    margin-right: 15px;
    width: 135px;
  }
`;

// #property-listing-show {
//   background-color: #eee;
//   display: inline-block;
//   width: 100%;
//   color: #555;

//   .property-listing-container {
//     max-width: 85rem;
//     margin: 20px auto;
//     padding: 0 20px;
//     border-radius: 5px;

//     .no-images {
//       font-size: 1.1em;
//       margin: 35px 0;
//     }

//     .address-price-container {
//       margin-top: 20px;
//       position: relative;
//       display: flex;
//       align-items: center;

//       .address,
//       .price {
//         display: inline-block;
//         font-size: 1.2em;
//       }

//       .address {
//         margin: 0;
//       }

//       .more-info-link {
//         position: absolute;
//         right: 15px;
//       }
//     }

//     .agent-info,
//     .office-info,
//     .description,
//     .property-details,
//     .building-details,
//     .address-price-container {
//       background-color: #fff;
//       padding: 15px;
//       border-radius: 5px;
//     }

//     .listing-agent-and-property-details-container {
//       display: flex;

//       @media only screen and (max-width: 64em) {
//         flex-wrap: wrap-reverse;
//       }

//       .listing-agent-and-office-details {
//         flex-grow: 0;

//         @media only screen and (min-width: 40.063em) and (max-width: 64em) {
//           display: flex;
//         }

//         .agent-info,
//         .office-info {
//           margin-top: 20px;
//           margin-right: 20px;

//           @media only screen and (max-width: 40em) {
//             margin-right: 0;
//           }

//           h2 {
//             font-size: 1.75rem;
//           }
//         }

//         .agent-info {
//           .image-name-and-position-container {
//             margin-bottom: 10px;

//             .listing-agent-image {
//               margin-bottom: 10px;
//             }

//             h2,
//             .position {
//               margin: 0;
//             }

//             .position {
//               margin-top: -6px;
//               color: #949494;
//             }
//           }

//           .listing-agent-details {
//             list-style-type: none;
//             margin: 0;
//           }

//           .wave {
//             width: 100%;
//             height: auto;
//             margin-top: 15px;
//           }
//         }

//         .office-info {
//           @media only screen and (max-width: 64em) {
//             margin-right: 0;
//           }

//           h2 {
//             margin-bottom: 15px;
//           }

//           address {
//             color: #575757;
//             font-weight: lighter;
//           }

//           .office-details {
//             list-style-type: none;
//             margin: 0;
//             margin-top: 10px;
//           }
//         }
//       }

//       .details {
//         .description,
//         .property-details,
//         .building-details {

//           .details-container {
//             .detail-entry {
//             }
//           }
//         }

//         .details-header {
//           p {
//             margin: 0;
//           }
//         }

//         label {
//           @media only screen and (min-width: 40.063em) {
//             font-size: 1em;
//           }
//         }
//       }
//     }
//   }
// }
